/**
 * Shared SEO meta helper for public marketing pages.
 * Generates title, description, OG, Twitter, and canonical tags.
 */
export function standardMeta({
    title,
    description,
    path = '',
}: {
    title: string
    description: string
    path?: string
}) {
    const url = `https://tsbuddy.pro${path}`
    return [
        { title },
        { name: 'description', content: description },
        // Open Graph
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: url },
        { property: 'og:type', content: 'website' },
        {
            property: 'og:image',
            content: 'https://tsbuddy.pro/favicons/android-chrome-512x512.png',
        },
        { property: 'og:site_name', content: 'Timesheet Buddy' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        {
            name: 'twitter:image',
            content: 'https://tsbuddy.pro/favicons/android-chrome-512x512.png',
        },
        // Canonical
        { tagName: 'link', rel: 'canonical', href: url },
    ]
}
